<template>
    <div class="login-box">
        <div class="qr-card">
            <div id="feishu-container"></div>
            <div class="scan-tip"><span class="dot"></span>请使用 <b>飞书 App</b> 扫描二维码登录</div>
            <div class="scan-sub">扫码后请在手机上确认授权</div>
        </div>
    </div>
</template>


<script>

import { feishuAppid } from '../config/index.js'
import { feishuLogin } from "../api/api.js";

export default {
    name: "FeishuLogin",
    data() {
        return {};
    },

    mounted() {
        const query = this.$route.query;
        const code = query.code
        console.log(`code:${code}`);
        if (code) {
            // 飞书授权后 302 回跳阶段：/login?redirect=xxx&code=xxx&state=STATE
            this.handleCodeLogin(code);
        } else {
            // 初始化二维码阶段
            this.feishuLoginInit();
        }
    },

    methods: {
        // 构造与拼进 QR goto 的 redirect_uri 完全一致的回调地址（未 encode 的原始 URL）
        // 回跳后 query.redirect 会被原样带回，因此可稳定重建
        buildRedirectUri() {
            const redirect_str = this.$route.query.redirect || '/'
            return `${window.location.origin}/login?redirect=${redirect_str}`
        },

        handleCodeLogin(code) {
            let tmp = {
                mode:3,
                code: code,
                tenant: 1,
                appid: feishuAppid,
                // 原样带给后端：飞书换 user_access_token 时要求 redirect_uri 与授权时一致
                redirect_uri: this.buildRedirectUri()
            }
            feishuLogin(tmp)
            .then((res) => {
                if (res['msg'] === '登录成功'){
                    this.$message.success("登录成功！")
                    this.$cookies.set("username", res['username'], "7d")
                    this.$cookies.set("token", res["token"], "7d")
                    this.$cookies.set("userid", res["userid"], "7d")
                    if (process.env.NODE_ENV === "development") {
                        // 本地联调：SPA 内跳转，避免跳到生产域名
                        this.$router.push("/")
                    } else {
                        // 生产：与原钉钉扫码登录保持一致
                        window.location.href = `http://dao.szltech.com/dao/#`
                    }
                } else {
                    this.$message.error(res['msg'] || '登录失败，请重试')
                }
            })
            .catch((err) => {
                console.log("feishuLogin err", err)
                this.$message.error("登录请求失败（网络或服务端错误），请打开控制台查看请求详情")
            })
        },

        feishuLoginInit() {
            const query = this.$route.query
            const redirect_str = query.redirect || '/'

            this.$store.commit("setRedirect", redirect_str)

            if (feishuAppid === "cli_xxxxxxxx") {
                console.warn("尚未配置飞书 App ID：src/config/index.js → feishuAppid")
            }

            // 回跳地址动态取当前域名：本地 http://localhost:8080/login，生产 http://dao.szltech.com/login
            // （需在飞书开放平台 安全设置→重定向 URL 中配置对应地址，query 后缀不参与匹配）
            const redirect_uri = this.buildRedirectUri()

            // 注意：与钉钉 DDLogin 不同，QRLogin 的 goto 传明文 URL，redirect_uri 值单独 encode
            const goto = `https://passport.feishu.cn/suite/passport/oauth/authorize` +
                `?client_id=${feishuAppid}` +
                `&redirect_uri=${encodeURIComponent(redirect_uri)}` +
                `&response_type=code&state=STATE`
            console.log("feishu goto", goto)

            if (typeof QRLogin === "undefined") {
                this.$message.error("飞书登录组件加载失败，请检查网络后刷新重试")
                return
            }

            const QRLoginObj = QRLogin({
                id: "feishu-container",
                goto: goto,
                width: "320",
                height: "300",
                style: "text-align:center;border:none;background-color:#FFFFFF;",
            });

            const handleMessage = (event) => {
                // 使用 SDK 提供的 matchOrigin/matchData 校验消息来源与数据合法性
                if (QRLoginObj.matchOrigin(event.origin) && QRLoginObj.matchData(event.data)) {
                    const loginTmpCode = event.data.tmp_code;
                    console.log("loginTmpCode", loginTmpCode);
                    // 拼接 tmp_code 跳转授权页，飞书授权后 302 回 redirect_uri 并携带 code
                    window.location.href = `${goto}&tmp_code=${loginTmpCode}`
                }
            };
            if (typeof window.addEventListener != "undefined") {
                window.addEventListener("message", handleMessage, false);
            } else if (typeof window.attachEvent != "undefined") {
                window.attachEvent("onmessage", handleMessage);
            }
        },
    }

}
</script>

<style scoped>

.login-box {
    margin-top: 20px;
}

/* 二维码区域：圆角浅底卡片，与登录卡片整体风格统一 */
.qr-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 14px 14px 18px;
    background: #f7f9fc;
    border: 1px solid #e8eef7;
    border-radius: 12px;
}

/* SDK 会把二维码 iframe 渲染进该容器，这里给二维码加圆角裁切 */
#feishu-container {
    overflow: hidden;
    border-radius: 8px;
    background: #ffffff;
}

.scan-tip {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 14px;
    font-size: 14px;
    color: #303a52;
}

.scan-tip b {
    margin: 0 3px;
    color: #2b5ce6;
    font-weight: 600;
}

.scan-sub {
    margin-top: 4px;
    font-size: 12px;
    color: #98a2b3;
}

/* 提示用的呼吸小圆点 */
.dot {
    width: 8px;
    height: 8px;
    margin-right: 6px;
    border-radius: 50%;
    background: #2b5ce6;
    box-shadow: 0 0 0 0 rgba(43, 92, 230, 0.45);
    animation: dotPulse 1.8s infinite;
}

@keyframes dotPulse {
    0%   { box-shadow: 0 0 0 0 rgba(43, 92, 230, 0.45); }
    70%  { box-shadow: 0 0 0 8px rgba(43, 92, 230, 0); }
    100% { box-shadow: 0 0 0 0 rgba(43, 92, 230, 0); }
}

@media (prefers-reduced-motion: reduce) {
    .dot {
        animation: none;
    }
}

</style>
